import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import type { SessionUserRoles } from '@rhino-project/core';
import { AppShell } from '../../components/shells/AppShell';
import { setLastOrgId } from '../../utils/prefStorage';

export const Route = createFileRoute('/_authenticated/$owner')({
  beforeLoad: ({ context: { rhino }, params: { owner } }) => {
    // Every page below this route is scoped to an organization, so an account
    // that belongs to none has nowhere here to land
    if (rhino.usersRoles.length === 0)
      throw redirect({ to: '/no-organization' });

    // This is a hack to make sure that the base owner is set correctly if deep linking into the app
    if (owner !== String(rhino.baseOwner?.id)) {
      const usersRoleFromUrl = rhino.usersRoles.find(
        (el: SessionUserRoles) => String(el.organization.id) === owner
      );

      if (usersRoleFromUrl) {
        rhino.setBaseOwner(usersRoleFromUrl.organization);
      } else {
        rhino.setBaseOwner(rhino.usersRoles[0].organization);
        throw redirect({
          to: `/$owner`,
          params: { owner: String(rhino.usersRoles[0].organization.id) }
        });
      }
    }

    setLastOrgId(owner);
  },
  component: RouteComponent
});

function RouteComponent() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
